// Copyright (c) 2017 Deere & Company

import CustomerSummary, {getDefaultState as getCustomerSummaryDefaultState} from './customer-summary';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import PipIndicator, {getDefaultState as getPipIndicatorDefaultState} from './pip-indicator';
import t from 'tcomb';

const StatusChangeProduct = t.struct({
    customerSummary: CustomerSummary,
    dealer: Dealer,
    model: t.String,
    pin: t.String,
    pip: t.String,
    pipIndicator: PipIndicator
}, {
    name: 'StatusChangeProduct',
    strict: true
});

export const getDefaultState = () => new StatusChangeProduct({
    customerSummary: getCustomerSummaryDefaultState(),
    dealer: getDealerDefaultState(),
    model: '',
    pin: '',
    pip: 'NONE',
    pipIndicator: getPipIndicatorDefaultState()
});

export default StatusChangeProduct;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/status-change-product.js